import { createRoutine } from "redux-saga-routines";

export const loadEventsByFiltersRoutine = createRoutine('LOAD_EVENTS_BY_FILTERS');

export const saveFiltersRoutine = createRoutine('SAVE_FILTERS');